function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useShowToast } from '@rd-web-markets/shared/dist/util/toast/useToast';
const api = buildService('/elsters/{id}/deminimis_subsidies', {
  only: ['create', 'update', 'delete']
});

/** Rails enum: subsidy_type — adjust if your API uses different integer/string values. */
export const DEMINIMIS_SUBSIDY_TYPE = {
  explanation_2: 0,
  explanation_3: 1
};
const mergeSubsidyIntoRegulation = (setRegulation, subsidyId, replacement) => {
  setRegulation(prev => {
    // if prev is defined we want to return prev here as it is. it could be an empty object. so basically in case it is undefined we don't want to proceed
    if (!prev) return prev;
    const list = prev.deminimis_subsidies || [];
    const next = list.map(s => s.id === subsidyId ? _objectSpread(_objectSpread({}, replacement), {}, {
      saved: true
    }) : s);
    return _objectSpread(_objectSpread({}, prev), {}, {
      deminimis_subsidies: next
    });
  });
};
const appendSubsidyToRegulation = (setRegulation, created) => {
  setRegulation(prev => {
    var _created$deminimis_su;
    // if prev is defined we want to return prev here as it is. it could be an empty object. so basically in case it is undefined we don't want to proceed
    if (!prev) return prev;
    const record = (_created$deminimis_su = created.deminimis_subsidy) !== null && _created$deminimis_su !== void 0 ? _created$deminimis_su : created;
    return _objectSpread(_objectSpread({}, prev), {}, {
      deminimis_subsidies: [...(prev.deminimis_subsidies || []), _objectSpread(_objectSpread({}, record), {}, {
        saved: true
      })]
    });
  });
};
const removeSubsidyFromRegulation = (setRegulation, subsidyId) => {
  setRegulation(prev => {
    // if prev is defined we want to return prev here as it is. it could be an empty object. so basically in case it is undefined we don't want to proceed
    if (!prev) return prev;
    return _objectSpread(_objectSpread({}, prev), {}, {
      deminimis_subsidies: (prev.deminimis_subsidies || []).filter(s => s.id !== subsidyId)
    });
  });
};
const deminimisSubsidyService = {
  useCreate: (elsterId, setLoading, setRegulation) => {
    const {
      t
    } = useTranslation();
    const showToast = useShowToast();
    const createSubsidy = serviceMethods.useCreate({
      callback: useCallback(async params => {
        const result = await api.create(elsterId, params);
        appendSubsidyToRegulation(setRegulation, result);
        showToast({
          message: t('subsidy_saved')
        });
        return result;
      }, [elsterId, setRegulation, showToast, t]),
      setLoading
    });
    return [createSubsidy];
  },
  useUpdate: (elsterId, setLoading, setRegulation) => {
    const {
      t
    } = useTranslation();
    const showToast = useShowToast();
    const updateSubsidy = serviceMethods.useUpdate({
      callback: useCallback(async _ref => {
        var _result$deminimis_sub;
        let {
          id,
          deminimis_subsidy
        } = _ref;
        const result = await api.update(elsterId, id, {
          deminimis_subsidy
        });
        const record = (_result$deminimis_sub = result.deminimis_subsidy) !== null && _result$deminimis_sub !== void 0 ? _result$deminimis_sub : result;
        mergeSubsidyIntoRegulation(setRegulation, id, record);
        showToast({
          message: t('subsidy_saved')
        });
        return result;
      }, [elsterId, setRegulation, showToast, t]),
      setLoading
    });
    return [updateSubsidy];
  },
  useDelete: (elsterId, setLoading, setRegulation) => {
    const {
      t
    } = useTranslation();
    const showToast = useShowToast();
    const deleteSubsidy = serviceMethods.useDelete({
      callback: useCallback(async subsidy => {
        if (!window.confirm(t('are_you_sure_you_want_to_remove_this_subsidy'))) return;
        await api.delete(elsterId, subsidy.id);
        removeSubsidyFromRegulation(setRegulation, subsidy.id);
        showToast({
          message: t('subsidy_deleted')
        });
      }, [elsterId, setRegulation, showToast, t]),
      setLoading
    });
    return [deleteSubsidy];
  }
};
deminimisSubsidyService.useCrud = (elsterId, setLoading, setRegulation) => {
  const [createSubsidy] = deminimisSubsidyService.useCreate(elsterId, setLoading, setRegulation);
  const [updateSubsidy] = deminimisSubsidyService.useUpdate(elsterId, setLoading, setRegulation);
  const [deleteSubsidy] = deminimisSubsidyService.useDelete(elsterId, setLoading, setRegulation);
  return {
    createSubsidy,
    updateSubsidy,
    deleteSubsidy
  };
};
export default deminimisSubsidyService;